// ⛔️Generated file. Manual changes will be lost ⛔️

import {Container} from 'esp-js-di';
import {ServiceClientContainerConsts} from './serviceClientIocConsts';
import {UserServiceClientImpl} from '@multipass-user-service';
import {PlatformServiceClientImpl} from '@multipass-platform-service';
import {LearningServiceClientImpl} from '@multipass-learning-service';

export const registerServiceClients = (container: Container, messagingClientConst: string) => {
    container.register(ServiceClientContainerConsts.multipassUserService_userService, UserServiceClientImpl)
        .inject(messagingClientConst)
        .singleton();
    container.register(ServiceClientContainerConsts.multipassPlatformService_platformService, PlatformServiceClientImpl)
        .inject(messagingClientConst)
        .singleton();
    container.register(ServiceClientContainerConsts.multipassLearningService_learningService, LearningServiceClientImpl)
        .inject(messagingClientConst)
        .singleton();
};
